<template>
	<div>
		<a-page-header style="background: #fff;" title="管理员管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'管理员管理'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addModal = true">
					添加管理员
				</a-button>
			</template>
		</a-page-header>

		<div class="mainBox">
			<!-- 列表 -->
			<div class="searchBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id">
					<span slot="action" slot-scope="text, record">
						<a @click="edit(record.id)">编辑</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加管理员弹窗 -->
		<a-modal title="添加管理员" :visible="addModal" @ok="addFormSubmit" @cancel="addModal = false" cancelText="取消" okText="添加">
			<a-form-model ref="addForm" :model="addForm" :rules="dataRules" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="账号" prop="account">
					<a-input placeholder="管理员账号" v-model="addForm.account" />
				</a-form-model-item>
				<a-form-model-item label="密码" prop="password">
					<a-input-password placeholder="请填写密码" v-model="addForm.password" type="password" />
				</a-form-model-item>
				<a-form-model-item label="确认密码" prop="rpassword">
					<a-input-password placeholder="请确认密码" v-model="addForm.rpassword" type="password" />
				</a-form-model-item>
				<a-form-model-item label="备注">
					<a-textarea placeholder="备注" v-model="addForm.beizhu" :rows="4" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 修改管理员弹窗 -->
		<a-modal title="编辑管理员" :visible="editVisible" @cancel="editVisible = false" :footer="null">
			<a-form-model ref="editForm" :model="editForm">
				<!--@submit="editFormSubmit"-->
				<a-form-model-item :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }" label="账号">
					<a-input placeholder="管理员账号" v-model="editForm.account" />
				</a-form-model-item>
				<a-form-model-item :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }" label="新密码(选填)">
					<a-input placeholder="请填写新密码" v-model="editForm.password" />
				</a-form-model-item>
				<a-form-model-item :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }" label="备注">
					<a-textarea placeholder="备注" :rows="4" v-model="editForm.beizhu" />
				</a-form-model-item>
				<a-form-model-item style="text-align: right;">
					<!--  html-type="submit" -->
					<a-button type="primary" @click="editFormSubmit">修改</a-button>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '账号',
			dataIndex: 'account',
		},
		{
			title: '添加时间',
			dataIndex: 'addtime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	const list = [];


	export default {
		data() {
			return {
				list,
				addForm: {},
				editForm: {},
				columns,
				addModal: false,
				editVisible: false,
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				labelCol: {
					span: 5
				},
				wrapperCol: {
					span: 14
				},
				dataRules: {
					account: [{
						required: true,
						message: '请填写账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请填写密码',
						trigger: 'blur'
					}],
					rpassword: [{
						required: true,
						message: '请再次填写密码',
						trigger: 'blur'
					}]
				},
			};
		},
		created() {
			this.getList();
		},
		methods: {
			getList() {
				this.$http.post('/admin/index.php/admin/Config/adminList').then(res => {
					if (res.data.code == 1) {
						this.list = res.data.data
					}
				})
			},

			edit(id) {
				console.log(id)
				let params = {
					id: id
				}
				this.$http.get('/admin/index.php/admin/Config/adminInfo', params).then((res) => {
					console.log(res.data)
					if (res.data.code == 1) {
						this.editForm = res.data.data
					}
				}).catch(err => {
					console.log(err)
				})
				this.editVisible = true;
			},

			del(id) {
				let params = {
					id: id
				}
				this.$http.get('/admin/index.php/admin/Config/adminDel', params).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg)
						this.getList()
					}
				})
			},

			addFormSubmit() {
				console.log(this.addForm)
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/config/adminSave', {
							account: this.addForm.account,
							password: this.addForm.password,
							rpassword: this.addForm.rpassword,
							beizhu: this.addForm.beizhu
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.addModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			editFormSubmit(e) {
				let params = {
					id: this.editForm.id,
					account: this.editForm.account,
					password: this.editForm.password,
					// rpassword: this.editForm.rpassword,
					sf: this.editForm.sf,
					beizhu: this.editForm.beizhu
				}
				this.$http.post('/admin/index.php/admin/Config/adminSave', params).then((res) => {
					console.log(res.data)
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.editVisible = false
						this.getList();
					}
					if (res.data.code == 2) {
						this.$message.error(res.data.msg);
					}
				})
			},
			handleChange(e) {
				console.log(e)
			}
		}
	};
</script>
